<template>
  <CHeader position="sticky" style="background-color: #010047">
    <CContainer fluid v-if="!this.$parent.mobileView">
      <CHeaderToggler class="ps-1" @click="$store.commit('toggleSidebar')">
        <CIcon style="color: white" icon="cil-menu" size="lg" />
      </CHeaderToggler>
      <CHeaderNav class="me-auto">
        <AppHeaderDropdownMerchant />
      </CHeaderNav>

      <CHeaderNav>
        <AppHeaderDropdownAccnt />
      </CHeaderNav>
    </CContainer>

    <CContainer v-if="this.$parent.mobileView">
      <CRow>
        <CCol style="width: 10%; flex: none">
          <CHeaderToggler
            class="px-0 py-0"
            @click="$store.commit('toggleSidebar')"
          >
            <CIcon style="color: white" icon="cil-menu" size="lg" />
          </CHeaderToggler>
        </CCol>
        <CCol style="width: 90%; padding-left: 0; margin-left: 12px">
          <CHeaderNav>
            <CNavItem>
              <CNavLink style="color: white; font-size: 20px; padding: 0">
                <AppHeaderDropdownMerchant />
              </CNavLink>
            </CNavItem>
          </CHeaderNav>
        </CCol>
      </CRow>
    </CContainer>
  </CHeader>
</template>

<script>
import { CCol, CRow } from '@coreui/vue'
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import AppHeaderDropdownMerchant from './AppHeaderDropdownMerchant.vue'
export default {
  name: 'AppHeader',
  components: {
    AppHeaderDropdownAccnt,
    CCol,
    CRow,
    AppHeaderDropdownMerchant
  },

  data() {
    return {}
  },
  created() {}
}
</script>
